// useValidationForm.js
import { useState } from 'react';
import { useLogin } from './../hooks/HookLogin';
import { message } from 'antd';

export const useValidationForm = (setEgresado, form) => {
    const { OnValidateEgresadoSirExistence } = useLogin();
    const [isValidated, setIsValidated] = useState(false);
    const [loading, setLoading] = useState(false);

    const validateEgresado = async () => {

        const values = await form.validateFields();
        setIsValidated(false);

        setLoading(true);

        const response = await OnValidateEgresadoSirExistence(values);
        setLoading(false);

        const alumno = response?.data?.alumno;
 
        if (response.success) {
            const tieneSAE = 'SAE' in alumno;
            const estatusEgresado = 'no_validado' in alumno;


            if (tieneSAE === estatusEgresado) {
                message.error("Ha ocurrido un error de formato al validar el egresado. Por favor, contacta al administrador.");
                return { success: false };
            }

            if (estatusEgresado && alumno?.no_validado) {
                message.error("Tu cuenta ya está registrada, pero aún no ha sido confirmada. Revisa tu correo y sigue las instrucciones.");
            }

            if (alumno?.SAE) {
                setIsValidated(true);
                form.setFieldsValue({ correo_institucional: alumno?.correo_institucional });
                //form.setFieldsValue({ correo_personal: alumno?.correo_personal });
                message.success("Alumno validado exitosamente");
            }

            setEgresado(alumno);
        }
        return response;
    };

    return { isValidated, validateEgresado, loading };
};
